import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-470f463d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Order NFTs", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-x" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row border-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 d-flex align-items-center" }, "Image"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 d-flex align-items-center" }, "Display Name"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 d-flex align-items-center" }, "NFT Id"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-flex align-items-center" }, "NFT Url")
], -1))
const _hoisted_11 = { class: "col-md-2 d-flex align-items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "col-md-2 d-flex align-items-center" }
const _hoisted_14 = { class: "col-md-2 d-flex align-items-center" }
const _hoisted_15 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "row my-2"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "No editions found for this order")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  class: "row my-2"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "popupNotification" }, null, 512),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-mask",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.oBackDropClick && _ctx.oBackDropClick(...args)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", {
                      class: "close-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                    }, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (!_ctx.isLoading && _ctx.nfts.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nfts, (nft) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "row my-1",
                                key: nft.NftId
                              }, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("img", {
                                    src: nft.ImageUrl,
                                    alt: "NFT image",
                                    class: "nft-image"
                                  }, null, 8, _hoisted_12)
                                ]),
                                _createElementVNode("div", _hoisted_13, _toDisplayString(nft.Displayname), 1),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(nft.NftId), 1),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("a", {
                                    class: "nft-url",
                                    href: nft.NftUrl,
                                    target: "_blank"
                                  }, _toDisplayString(nft.NftUrl), 9, _hoisted_16),
                                  _createElementVNode("span", {
                                    class: "k-icon k-i-copy k-icon-64 k-cursor-pointer k-px-5",
                                    onClick: ($event: any) => (
                        _ctx.copyUrlToClipboard(nft.NftUrl)
                      )
                                  }, null, 8, _hoisted_17)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoading && _ctx.nfts.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                      : _createCommentVNode("", true),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "btn btn-danger",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
                        }, "Close")
                      ])
                    ], true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}